import React, { FC, useMemo } from "react";
import Link from "next/link";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { useStore } from "store";
import { useBreakpoint, useUrl } from "helpers/hooks";
import styles from "./Examples.module.scss";

type Props = {
  onClick?: (value: string) => void;
};

const Examples: FC<Props> = ({ onClick }) => {
  const { getEntityLinkProps } = useUrl();
  const { search } = useStore();
  const gtTablet = ["laptop", "desktop"].includes(useBreakpoint(true));
  const examples = useMemo(() => {
    return toJS(search.help).filter(item => item.value && item.url);
  }, [search.help]);

  if (!gtTablet) return null;

  return (
    <div className={styles.examples}>
      {examples.length > 0 && (
        <>
          Например:{" "}
          {examples.map((example, i) => (
            <Link
              key={i}
              {...getEntityLinkProps("search", { alias: example.value })}
              onClick={() => onClick(example.value)}
            >
              <span>
                {example.value}
                {examples.length > i + 1 && ", "}
              </span>
            </Link>
          ))}
        </>
      )}
    </div>
  );
};

export default observer(Examples);
